<login-container titel="Log ind med..." [arbejder]="forbrugerNrArbejder || emailArbejder || false || biometricLoginInProgress">
    @if (dashboardStatus && dashboardStatus.freetext && dashboardStatus.login) {
        <div
            class="dashboard-status"
            [style]="{
                background: dashboardStatus.status === 'error' ? '#f8d7da' : dashboardStatus.status === 'warning' ? '#fff3cd' : '#fff',
                border: dashboardStatus.status === 'error' ? '2px solid #b71c1c' : dashboardStatus.status === 'warning' ? '2px solid #bfa100' : '2px solid #ccc'
            }"
        >
            <p [innerHTML]="dashboardStatus.freetext"></p>
        </div>
    }

    <mat-tab-group (selectedTabChange)="onSelectedTabChange($event)">
        <mat-tab label="Forbrugernummer" id="login-forbruger-nummer-tab">
            <login-forbrugernr
                id="login-forbruger-nummer"
                #loginForbrugerNr
                [parent]="form"
                [fejlBesked]="fejlBesked"
                (loginSucceeded)="onLoginSucceeded()"
                (alphaKeyPressed)="onForbrugerNrAlphaKeyPressed($event)"
                (arbejderChange)="onForbrugerNrArbejderChange($event)"
            >
                <ng-template #biometricLoginButton>
                    @if (isBiometricAvailable) {
                        <button mat-raised-button color="secondary" type="button" (click)="biometricLogin()" [disabled]="!isBiometricAvailable">
                            {{
                                biometricEnabled
                                    ? passwordFilled && loginInputFilled
                                        ? `Opdater ${biometricActionText} loginoplysninger`
                                        : `Log ind med ${biometricActionText}`
                                    : `Aktiver ${biometricActionText} login`
                            }}
                        </button>
                    }
                </ng-template>
            </login-forbrugernr>
        </mat-tab>
        <mat-tab label="E-mail" id="login-email-tab">
            <login-email
                #loginEmail
                id="login-email"
                [parent]="form"
                [fejlBesked]="fejlBesked"
                (loginSucceeded)="onLoginSucceeded()"
                (arbejderChange)="onEmailArbejderChange($event)"
            >
                <ng-template #biometricLoginButton>
                    @if (isBiometricAvailable) {
                        <button mat-raised-button color="secondary" type="button" (click)="biometricLogin()" [disabled]="!isBiometricAvailable">
                            {{
                                biometricEnabled
                                    ? passwordFilled && loginInputFilled
                                        ? `Opdater ${biometricActionText} loginoplysninger`
                                        : `Log ind med ${biometricActionText}`
                                    : `Aktiver ${biometricActionText} login`
                            }}
                        </button>
                    }
                </ng-template>
            </login-email>
        </mat-tab>
    </mat-tab-group>
</login-container>
